import React, { Component } from "react";
import CourseLanding from './screens/CourseLanding/CourseLanding';
//import CourseIndexLanding from './screens/CourseIndexLanding/CourseIndexLanding';

import { Routes, Route } from 'react-router-dom';

import './App.css';


class App extends Component {

  constructor(props){ 
    super(props);
        
    this.state = {};

  } 


  
            /* CURSOS
          <Route path="en/tattoo-training-test/" element={<CourseIndexLanding language="en" />} />
          <Route path="es/cursos-test/" element={<CourseIndexLanding language="es" />} />
          <Route path="en/cours-test/" element={<CourseIndexLanding language="fr" />} />
          <Route path="pt/cursos-test/" element={<CourseIndexLanding language="pt" />} />
          */

  

  componentDidMount() {
  }

  render () {

    return (
      <>
        <Routes>
          <Route path="en/tattoo-training/:courseSlug" element={<CourseLanding language="en" />} />
          <Route path="es/cursos/:courseSlug" element={<CourseLanding language="es" />} />
          <Route path="fr/cours/:courseSlug" element={<CourseLanding language="fr" />} />
          <Route path="pt/cursos/:courseSlug" element={<CourseLanding language="pt" />} />
        </Routes>
      </>
    );

  }
}

export default App;
